import { apiFetch } from './client';

export const appointmentsApi = {
  list: (filters = {}) =>
    apiFetch('/api/appointments', {
      params: {
        // Legacy params — kept so existing callers still work.
        start_date: filters.startDate,
        end_date: filters.endDate,
        status: filters.status,
        // Phase 6A filters — richer appointment querying.
        appointment_type: filters.appointment_type,
        assigned_user_id: filters.assigned_user_id,
        lead_id: filters.lead_id,
        call_id: filters.call_id,
        needs_review: filters.needs_review,
        date_from: filters.date_from,
        date_to: filters.date_to,
        dealer_id: filters.dealer_id,
        limit: filters.limit,
        offset: filters.offset,
      },
    }),
  get: (id) => apiFetch(`/api/appointments/${id}`),
  create: (data) => apiFetch('/api/appointments', { method: 'POST', body: data }),
  update: (id, patch) => apiFetch(`/api/appointments/${id}`, { method: 'PUT', body: patch }),
  remove: (id) => apiFetch(`/api/appointments/${id}`, { method: 'DELETE' }),
  sendConfirmationSms: (id) =>
    apiFetch(`/api/sms/send-confirmation/${id}`, { method: 'POST' }),
  sendReminderSms: (id) =>
    apiFetch(`/api/sms/send-reminder/${id}`, { method: 'POST' }),
  smsStatus: () => apiFetch('/api/sms/status'),
  // Phase 6A — status-transition endpoints. Each returns the updated appointment.
  confirm: (id) => apiFetch(`/api/appointments/${id}/confirm`, { method: 'POST', body: {} }),
  cancel: (id) => apiFetch(`/api/appointments/${id}/cancel`, { method: 'POST', body: {} }),
  complete: (id) => apiFetch(`/api/appointments/${id}/complete`, { method: 'POST', body: {} }),
  noShow: (id) => apiFetch(`/api/appointments/${id}/no-show`, { method: 'POST', body: {} }),
  approveReview: (id) =>
    apiFetch(`/api/appointments/${id}/approve-review`, { method: 'POST', body: {} }),
  // Phase 6C — calendar sync + reminder/confirmation endpoints.
  syncCalendar: (id) => apiFetch(`/api/appointments/${id}/sync-calendar`, { method: 'POST', body: {} }),
  sendConfirmation: (id) => apiFetch(`/api/appointments/${id}/send-confirmation`, { method: 'POST', body: {} }),
  sendReminder: (id) => apiFetch(`/api/appointments/${id}/send-reminder`, { method: 'POST', body: {} }),
  // Phase 6D — reminder scheduler + availability suggestions.
  runDueReminders: ({ dryRun = false } = {}) =>
    apiFetch('/api/appointments/reminders/run-due', {
      method: 'POST',
      params: { dry_run: dryRun ? 'true' : 'false' },
      body: {},
    }),
  getAvailability: (params) =>
    apiFetch('/api/appointments/availability', { params }),
};
